import { Component, OnInit, } from '@angular/core'
import { AppConfigService } from '../../service/app-config.service'
import { PersonService } from '../../service/person.service'
declare var $: any
@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class MembershipComponent implements OnInit {
  modal = {
    title: 'ChinaICAC Member Sign in',
    isSigninShow: false,
    closeShow: true,
  };
  path = [
    { id: 'path1', label: 'About ChinaICAC Membership', top: 30 },
    { id: 'path2', label: 'Member Benefits', top: 76 },
    { id: 'path3', label: 'Membership Eligibility and Categories', top: 134 },
    { id: 'path4', label: 'Membership and Fees', top: 190 },
    { id: 'path5', label: 'Membership Year', top: 236 },
    { id: 'path6', label: 'Membership Vetting and Documentation', top: 294 },
    { id: 'path7', label: 'Member Expectations and Organizational Values', top: 362 },
    { id: 'path8', label: 'Membership Violations and Appeals', top: 430 },
    { id: 'path9', label: 'Conference Attendance, Partnership, and Volunteering for Committees', top: 509 },
  ]
  floatOpen: any = false;
  currentName: any = null;
  top: any = null;
  fun: any = null;

  isshow1: boolean
  isshow2: boolean
  notlogin: boolean

  download1: string

  constructor(private personService: PersonService,
    private appconfigService: AppConfigService,) {
    this.isshow1 = true
    this.isshow2 = false
    this.notlogin = true
    this.download1 = "javascript:void(0);"
    this.download()

    this.currentName = 0
    this.top = this.path[this.currentName].top


  }

  ngOnInit() {
    let that = this
    let scrollTopArray = [] 
    this.path.map((item,index)=>{
      if ($(`#${item.id}`).offset().top){
        scrollTopArray[index] = Math.floor($(`#${item.id}`).offset().top)
      }   
    })
    console.log('scrollTopArray',scrollTopArray)
    // [260, 995, 1544, 2463, 2827, 3236, 4549, 5723, 6243]
    // document.getElementsByTagName('body')[0].onscroll = function(){
    //   that.setbar();
    // };
    window.onscroll = function () {
      that.setbar()
    }
    // this.setFooter();
    setTimeout(function () {
      $('.wrap-box').css("min-height", $(window).height())
    }, 0)

    this.fun = () => {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop

      // console.log(scrollTop)
      if (scrollTop < 230 ){
        this.floatOpen = false
      } else {
        this.floatOpen = true
      }
      //240
      if (scrollTop < scrollTopArray[1]) {
        this.currentName = 0
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[2]) {
        this.currentName = 1
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[3]) {
        this.currentName = 2
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[4]) {
        this.currentName = 3
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[5]) {
        this.currentName = 4
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[6]) {
        this.currentName = 5
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[7]) {
        this.currentName = 6
        this.top = this.path[this.currentName].top
      } else if (scrollTop < scrollTopArray[8]) {
        this.currentName = 7
        this.top = this.path[this.currentName].top
      } else {
        this.currentName = 8
        this.top = this.path[this.currentName].top
      }
    }
    window.addEventListener('scroll', this.fun)
  }

  touchTab(e) {
    document.getElementById(this.path[e].id).scrollIntoView({
      behavior: "smooth"
    })
    // this.currentName = e
    // this.top = this.path[e].top
    this.fun()
  }

  setFooter() {
    if ($('body').height() < $(window).height()) {
      $('footer').css({ "position": "fixed", "bottom": "0" })
    } else {
      $('footer').css({ "position": "relative", "bottom": "auto" })
    }

    window.onload = function () {
      if ($('body').height() < $(window).height()) {
        $('footer').css({ "position": "fixed", "bottom": "0" })
      } else {
        $('footer').css({ "position": "relative", "bottom": "auto" })
      }
    }

    window.onresize = function () {
      if ($('body').height() < $(window).height()) {
        $('footer').css({ "position": "fixed", "bottom": "0" })
      } else {
        $('footer').css({ "position": "relative", "bottom": "auto" })
      }
    }
  }

  setbar() {
    const top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0
    if (top <= 230) {
      if (document.getElementById('nav-right')) {
        document.getElementById('nav-right').style.top = '0px'
      }
    } else {
      if (document.getElementById('nav-right')) {
        document.getElementById('nav-right').style.top = (top - 230).toString() + 'px'
      }
    }
  }

  show(msg) {
    switch (msg) {
      case 'membership':
        this.isshow1 = true
        this.isshow2 = false
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        this.setbar()
        break
      case 'benefit':
        this.isshow1 = false
        this.isshow2 = true
        document.body.scrollTop = document.getElementById('membershipsystem').clientHeight + 230
        document.documentElement.scrollTop = document.getElementById('membershipsystem').clientHeight + 230
        this.setbar()
        break
      default:
        break
    }
  }

  onConfirm() {
    this.modal.isSigninShow = false
  }

  download() {
    this.personService.getUserInfo().subscribe(res => {
      res.ok ? this.setdownloadurl(res.data) : this.notlogin = true
    })
  }

  ifdownload() {
    this.modal.isSigninShow = true
  }

  setdownloadurl(data) {
    this.notlogin = false
    this.modal.isSigninShow = false
    if (data.userRole = 0) {
      this.download1 = this.appconfigService.api + '//user/excel/0'
      // window.open(this.appconfigService.api +' //user/excel/0',"_blank");
    } else {
      // window.open(this.appconfigService.api + '//user/excel/1',"_blank");
      this.download1 = this.appconfigService.api + '//user/excel/1'
    }
  }

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/membership/membership/membership.component.ts